import config from "@/config";
import MPSessionStorage from "@/services/MPSessionStorage";
export var PARTNER_HUB_V2_FORCE_REDIRECT_GATE = "partner_redirect_v1_to_v2";
export var HUB_REDIRECTED_PARAM = "hub_redirected";
var REDIRECT_MARK_WINDOW_MS = 10000;
var REDIRECT_MARK_KEY = "".concat(config.localStoragePrefixMP, ".PHUB_V2_FORCE_REDIRECT_AT");
var DASHBOARD_ROOT = "/dashboard";
var PARTNER_SIGNUP_ENTRY_PATH = "/auth/signup/partner";
var PARTNER_SIGNUP_V2_PATH = "/partner/signup";
var PARTNER_SECTION_ALIAS = "/dashboard/partner";
var PARTNER_SECTION_WITH_ID = /^\/dashboard\/partners\/partner\/[^/]+(\/.*)?$/;
var IO_LANDING_PATH = /^\/(?:dashboard\/app|lp\/migrate)\//;
var isUnderPath = function (pathname, prefix) {
    return pathname === prefix || pathname.indexOf("".concat(prefix, "/")) === 0;
};
var normalizePath = function (pathname) {
    return pathname.length > 1 && pathname.charAt(pathname.length - 1) === "/"
        ? pathname.slice(0, pathname.length - 1)
        : pathname;
};
var toSearchParams = function (search) {
    return new URLSearchParams(search.charAt(0) === "?" ? search.slice(1) : search);
};
export var isPartnerSignupEntryPath = function (pathname) {
    return normalizePath(pathname) === PARTNER_SIGNUP_ENTRY_PATH;
};
// Old client-paid partner links (/?bundle_id=..&force_client_pay=true) can
// land on any v1 path, and the login redirect to /partner/:id drops the params.
// Mirrors v1, which treats any non-empty value as client-paid, except "false".
export var isClientPaidPartnerLink = function (search) {
    var value = (toSearchParams(search).get("force_client_pay") || "")
        .trim()
        .toLowerCase();
    return value !== "" && value !== "false";
};
export var isPartnerHubV2RedirectExcludedPath = function (pathname) {
    var path = normalizePath(pathname);
    if (!isUnderPath(path, DASHBOARD_ROOT))
        return true;
    // Canny SSO handoff must run on v1
    if (isUnderPath(path, "/dashboard/sso"))
        return true;
    // IO flow, owned by partner_io_v1_to_v2
    if (isUnderPath(path, "/dashboard/app"))
        return true;
    return false;
};
export var isIoLocalizationPending = function () {
    try {
        var saved = MPSessionStorage.get(MPSessionStorage.keys.NEW_LOCALIZTIONS);
        return Boolean(saved && IO_LANDING_PATH.test(saved));
    }
    catch (error) {
        return false;
    }
};
var partnerSectionRules = [
    {
        rule: "partner_root",
        kind: "exact",
        pattern: /^$/,
        toPath: function (pid) { return "/partner/".concat(pid); }
    },
    {
        rule: "pipes",
        kind: "exact",
        pattern: /^\/pipes$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/numbers"); }
    },
    {
        rule: "pipes_channel",
        kind: "exact",
        pattern: /^\/pipes\/client\/([^/]+)\/project\/[^/]+\/channel\/([^/]+)$/,
        toPath: function (pid, ids) {
            return "/partner/".concat(pid, "/clients/").concat(ids[0], "/numbers/").concat(ids[1], "/details");
        }
    },
    {
        rule: "pipes_project",
        kind: "nearest",
        pattern: /^\/pipes\/client\/([^/]+)\/project\/[^/]+$/,
        toPath: function (pid, ids) { return "/partner/".concat(pid, "/clients/").concat(ids[0], "/numbers"); }
    },
    {
        rule: "pipes_waba_account",
        kind: "nearest",
        pattern: /^\/pipes\/client\/([^/]+)\/waba-account\/[^/]+$/,
        toPath: function (pid, ids) { return "/partner/".concat(pid, "/clients/").concat(ids[0], "/numbers"); }
    },
    {
        rule: "pipes_client",
        kind: "exact",
        pattern: /^\/pipes\/client\/([^/]+)$/,
        toPath: function (pid, ids) { return "/partner/".concat(pid, "/clients/").concat(ids[0]); }
    },
    {
        rule: "pipes_add_number",
        kind: "nearest",
        pattern: /^\/pipes\/(?:add-number|add-number-flow|migrate-number)$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/numbers"); }
    },
    {
        rule: "pipes_add_payment",
        kind: "nearest",
        pattern: /^\/pipes\/add-payment\/([^/]+)$/,
        toPath: function (pid, ids) { return "/partner/".concat(pid, "/clients/").concat(ids[0]); }
    },
    {
        rule: "pipes_violations",
        kind: "nearest",
        pattern: /^\/pipes\/[^/]+\/violations\/[^/]+$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/numbers"); }
    },
    {
        rule: "pipes_other",
        kind: "nearest",
        pattern: /^\/pipes\/.*$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/numbers"); }
    },
    {
        rule: "clients",
        kind: "exact",
        pattern: /^\/clients(?:\/.*)?$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/clients"); }
    },
    {
        rule: "users",
        kind: "nearest",
        pattern: /^\/users(?:\/.*)?$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/settings"); }
    },
    {
        rule: "details",
        kind: "nearest",
        pattern: /^\/details$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/settings"); }
    },
    {
        rule: "profile",
        kind: "exact",
        pattern: /^\/profile$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/settings"); }
    },
    {
        rule: "integration",
        kind: "exact",
        pattern: /^\/integration$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/integration"); }
    },
    {
        rule: "api_key_management",
        kind: "nearest",
        pattern: /^\/api-key-management$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/integration"); }
    },
    {
        rule: "onboarding",
        kind: "exact",
        pattern: /^\/onboarding$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/onboarding"); }
    },
    {
        rule: "edit_partner",
        kind: "nearest",
        pattern: /^\/edit-partner\/[^/]+$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/settings"); }
    }
];
var topLevelRules = [
    {
        rule: "dashboard_root",
        kind: "exact",
        pattern: /^\/dashboard$/,
        toPath: function (pid) { return "/partner/".concat(pid); }
    },
    {
        rule: "partners_list",
        kind: "nearest",
        pattern: /^\/dashboard\/partners$/,
        toPath: function (pid) { return "/partner/".concat(pid); }
    },
    {
        rule: "home",
        kind: "nearest",
        pattern: /^\/dashboard\/home$/,
        toPath: function (pid) { return "/partner/".concat(pid); }
    },
    {
        rule: "waba",
        kind: "nearest",
        pattern: /^\/dashboard\/waba(?:\/.*)?$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/numbers"); }
    },
    {
        rule: "sandbox",
        kind: "exact",
        pattern: /^\/dashboard\/sandbox$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/sandbox"); }
    },
    {
        // No v2 analytics page yet - a deliberate fallback so monitoring sees it.
        rule: "analytics",
        kind: "fallback",
        pattern: /^\/dashboard\/analytics$/,
        toPath: function (pid) { return "/partner/".concat(pid); }
    },
    {
        rule: "billing_options",
        kind: "nearest",
        pattern: /^\/dashboard\/billing-options$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/billing-options/billing"); }
    },
    {
        rule: "billing_balance",
        kind: "exact",
        pattern: /^\/dashboard\/billing\/balance$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/billing-options/funds"); }
    },
    {
        rule: "billing_invoices",
        kind: "exact",
        pattern: /^\/dashboard\/billing\/invoices$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/billing-options/invoices"); }
    },
    {
        rule: "billing",
        kind: "nearest",
        pattern: /^\/dashboard\/billing(?:\/.*)?$/,
        toPath: function (pid) { return "/partner/".concat(pid, "/billing-options/billing"); }
    },
    {
        rule: "preferences",
        kind: "nearest",
        pattern: /^\/dashboard\/preferences$/,
        toPath: function () { return "/general/account"; }
    }
];
var getPartnerSectionRest = function (path) {
    var withIdMatch = path.match(PARTNER_SECTION_WITH_ID);
    if (withIdMatch)
        return withIdMatch[1] || "";
    if (path === PARTNER_SECTION_ALIAS)
        return "";
    if (path.indexOf("".concat(PARTNER_SECTION_ALIAS, "/")) === 0) {
        return path.slice(PARTNER_SECTION_ALIAS.length);
    }
    return null;
};
var applyRules = function (rules, input, partnerId) {
    for (var index = 0; index < rules.length; index++) {
        var entry = rules[index];
        var match = input.match(entry.pattern);
        if (match) {
            return {
                path: entry.toPath(partnerId, match.slice(1)),
                kind: entry.kind,
                rule: entry.rule
            };
        }
    }
    return null;
};
var toPartnerRoot = function (partnerId, rule) { return ({
    path: "/partner/".concat(partnerId),
    kind: "fallback",
    rule: rule
}); };
// Uses partnerId, not the URL id: v1 shows non-admins the active partner.
export var mapPartnerHubPathToV2 = function (pathname, partnerId) {
    var path = normalizePath(pathname);
    var partnerSectionRest = getPartnerSectionRest(path);
    if (partnerSectionRest !== null) {
        return (applyRules(partnerSectionRules, partnerSectionRest, partnerId) ||
            toPartnerRoot(partnerId, "fallback_partner_root"));
    }
    return (applyRules(topLevelRules, path, partnerId) ||
        toPartnerRoot(partnerId, "fallback_root"));
};
export var buildPartnerHubV2RedirectUrl = function (args) {
    var mapping = mapPartnerHubPathToV2(args.pathname, args.partnerId);
    var params = toSearchParams(args.search);
    params.set(HUB_REDIRECTED_PARAM, "true");
    params.set("orgName", args.partnerId.toLowerCase());
    var baseUrl = args.baseUrl.replace(/\/+$/, "");
    return { url: "".concat(baseUrl).concat(mapping.path, "?").concat(params.toString()), mapping: mapping };
};
// No orgName: the organisation the partner will belong to does not exist yet.
export var buildPartnerSignupV2RedirectUrl = function (args) {
    var params = toSearchParams(args.search);
    // v2 only accepts exactly "true", so normalise what v1 accepted (=1, =TRUE).
    if (isClientPaidPartnerLink(args.search)) {
        params.set("force_client_pay", "true");
    }
    params.set(HUB_REDIRECTED_PARAM, "true");
    var baseUrl = args.baseUrl.replace(/\/+$/, "");
    return "".concat(baseUrl).concat(PARTNER_SIGNUP_V2_PATH, "?").concat(params.toString());
};
export var markPartnerHubV2Redirect = function () {
    try {
        sessionStorage.setItem(REDIRECT_MARK_KEY, String(Date.now()));
    }
    catch (error) { }
};
export var wasPartnerHubV2RedirectJustPerformed = function (windowMs) {
    if (windowMs === void 0) { windowMs = REDIRECT_MARK_WINDOW_MS; }
    try {
        var marked = sessionStorage.getItem(REDIRECT_MARK_KEY);
        if (!marked)
            return false;
        var markedAt = Number(marked);
        if (isNaN(markedAt))
            return false;
        var delta = Date.now() - markedAt;
        // A future mark means clock skew, so it fails open instead of latching.
        return delta >= 0 && delta < windowMs;
    }
    catch (error) {
        return false;
    }
};
//# sourceMappingURL=data:application/json;base64,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